import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import {
  findImageByKeyWithoutFallBack,
  findValueByKey,
  applyTruncationForScreen,
  isLinkAbsolute,
  isItUndefined,
  stripHtml,
  removeNbsp,
  getResourceContentImageSrc,
  getTarget,
} from '../../util/DataUtil';

const ResourceContent = ({ featured, title, onChipClick, width, global }) => {
  const router = useRouter();
  const [titles, setTitles] = useState([]);

  const truncate = () => {
    let titles = [];

    featured.forEach((item, index) => {
      titles.push(
        applyTruncationForScreen(
          findValueByKey(
            'template_title_block_type',
            item?.field_template_blocks
          )?.field_template_title
            ? findValueByKey(
                'template_title_block_type',
                item?.field_template_blocks
              )?.field_template_title[0]?.value
            : findValueByKey(
                  'hero_graphic_block_type',
                  item?.field_template_blocks
                )?.field_formatted_title
              ? removeNbsp(
                  stripHtml(
                    findValueByKey(
                      'hero_graphic_block_type',
                      item?.field_template_blocks
                    )?.field_formatted_title[0]?.value
                  )
                )
              : '',
          index === 0 ? 120 : 47,
          50,
          60
        )
      );
    });
    setTitles(titles);
  };

  useEffect(() => {
    truncate();
  }, [featured]);

  const renderFeatured = () => {
    return featured.map((item, index) => {
      if (index === 0) {
        return;
      }
      if (
        item.field_template_tertiary_category.length > 0 &&
        (item.field_metro_name || item.field_facility_location)
      ) {
        return;
      }
      return (
        <a
          key={index}
          className={'item'}
          href={item['url-alias'].length !== 0 ? item['url-alias'] : '/'}
          target={getTarget(item['url-alias'])}
        >
          {index === 1 && (
            <div className={'div-resource-content-link img-container'}>
              <Image
                priority
                layout="fill"
                alt="featured"
                src={getResourceContentImageSrc(item)}
              />
            </div>
          )}
          <span
            // onClick={(event) => onChipClick(event, [{name : item?.field_template_category[0]?.name}])}
            className={'category'}
          >
            {item &&
              item?.field_content_type_templat &&
              item?.field_content_type_templat[0]?.name && (
                <>
                  {item?.field_content_type_templat[0]?.name}
                  {isItUndefined(item?.field_time_to_read) ? ',' : ''}{' '}
                  {isItUndefined(item?.field_time_to_read)}
                </>
              )}
            {item && item?.field_page_type?.[0]?.value == 'Main' && (
              <span className={'category'}>
                {global?.field_global_data_centre_locatio?.[0]?.value}
              </span>
            )}
            {item && item?.field_metro_name && (
              <span className={'category'}>
                {global?.field_metro_label?.[0]?.value}
              </span>
            )}
            {item && item?.field_region_name && (
              <span className={'category'}>
                {global?.field_region_label?.[0]?.value}
              </span>
            )}
            {item && item?.field_facility_location && (
              <span className={'category'}>
                {global?.field_facility_label?.[0]?.value}
              </span>
            )}
            {item &&
              item?.field_page_type &&
              ['Products', 'Partners', 'Insights', 'Solutions'].includes(
                item?.field_page_type[0]?.value
              ) && (
                <>
                  {item?.field_page_type[0]?.value}
                  {isItUndefined(item?.field_time_to_read) ? ',' : ''}{' '}
                  {isItUndefined(item?.field_time_to_read)}
                </>
              )}
          </span>
          <span className={'title span-resource-content-link'}>
            {titles[index] || renderLocationsTitle(item)}
          </span>
          {item?.field_template_category &&
          item?.field_template_category[0]?.name ? (
            <span
              className={'second-category category-hover'}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onChipClick(event, [
                  { name: item?.field_template_category[0]?.name },
                ]);
              }}
            >
              {item?.field_template_category[0]?.name}
            </span>
          ) : (
            <span
              className={'second-category second-category-0-mt category-hover'}
            ></span>
          )}
          <hr />
        </a>
      );
    });
  };

  const renderLocationsTitle = (data) => {
    if (data.field_metro_name) {
      return `${data?.field_metro_name?.[0]?.name} ${global?.field_data_centers_label?.[0]?.value}`;
    } else if (data.field_facility_location) {
      return `${data?.field_facility_location?.[0]?.name} ${global?.field_data_centers_label?.[0]?.value}`;
    } else if (data.field_region_name) {
      return `${data?.field_region_name?.[0]?.name} ${global?.field_data_centers_label?.[0]?.value}`;
    } else if (data.field_template_blocks[0].header_block_type) {
      const title =
        data?.field_template_blocks?.[0]?.header_block_type?.field_title?.[0]
          ?.value;
      if (title) {
        // Split the title into words
        const words = title.split(' ');

        // Capitalize the first letter of each word
        const capitalizedWords = words.map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1)
        );

        // Join the capitalized words back into a string
        const formattedTitle = capitalizedWords.join(' ');

        return formattedTitle;
      }
    }
  };

  const renderMainFeatured = () => {
    return (
      <div className={'item-big'}>
        <a
          href={
            featured[0]?.['url-alias'].length !== 0
              ? featured[0]?.['url-alias']
              : '/'
          }
          target={getTarget(featured[0]?.['url-alias'])}
          className={'img-container div-resource-content-link'}
        >
          <Image
            layout="fill"
            alt="featured"
            src={getResourceContentImageSrc(featured[0])}
          />
        </a>
        {featured[0] && featured[0]?.field_page_type?.[0]?.value == 'Main' && (
          <span className={'category'}>
            {global?.field_global_data_centre_locatio?.[0]?.value}
          </span>
        )}
        {featured[0] && featured[0]?.field_metro_name && (
          <span className={'category'}>
            {global?.field_metro_label?.[0]?.value}
          </span>
        )}
        {featured[0] && featured[0]?.field_region_name && (
          <span className={'category'}>
            {global?.field_region_label?.[0]?.value}
          </span>
        )}
        {featured[0] && featured[0]?.field_facility_location && (
          <span className={'category'}>
            {global?.field_facility_label?.[0]?.value}
          </span>
        )}
        {featured[0] &&
          featured[0]?.field_content_type_templat &&
          featured[0]?.field_content_type_templat[0]?.name && (
            <span className={'category'}>
              {featured[0]?.field_content_type_templat[0]?.name}
              {isItUndefined(featured[0]?.field_time_to_read) ? ',' : ''}{' '}
              {isItUndefined(featured[0]?.field_time_to_read)}
            </span>
          )}
        {featured[0] &&
          featured[0]?.field_page_type &&
          ['Products', 'Partners', 'Insights', 'Solutions'].includes(
            featured[0]?.field_page_type[0]?.value
          ) && (
            <>
              <span className="category">
                {featured[0]?.field_page_type[0]?.value}
                {isItUndefined(featured[0]?.field_time_to_read) ? ',' : ''}{' '}
                {isItUndefined(featured[0].field_time_to_read)}
              </span>
            </>
          )}
        <a
          href={
            featured[0]?.['url-alias'].length !== 0
              ? featured[0]?.['url-alias']
              : '/'
          }
          target={getTarget(featured[0]?.['url-alias'])}
          className={'resource-title-link'}
        >
          <span className={'title'}>
            {titles[0] || renderLocationsTitle(featured[0])}
          </span>
        </a>
        {featured[0]?.field_template_category &&
        featured[0]?.field_template_category[0]?.name ? (
          <span
            className={'second-category category-hover'}
            onClick={(event) =>
              onChipClick(event, [
                { name: featured[0]?.field_template_category[0]?.name },
              ])
            }
          >
            {featured[0]?.field_template_category[0]?.name}
          </span>
        ) : (
          <span className="second-category second-category-0-mt category-hover"></span>
        )}
        <hr className={'item-big-hr'} />
      </div>
    );
  };

  return (
    <div className={'resource-content'}>
      <div className={'inner-container'}>
        <span
          className={'page-sub'}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <hr />
        <div className={'featured'}>
          {renderMainFeatured()}
          <div className={'small-items'}>{renderFeatured()}</div>
        </div>
      </div>
    </div>
  );
};

export default ResourceContent;
